/**
 * mediaTypes.ts
 *
 * Narrow projection types for the media picker layer.
 * These are the only shapes picker components return — they are projections
 * of DocumentInterface, not replacements. Mutation logic still uses the
 * full DocumentInterface from types.ts.
 */

import type { DocumentInterface } from './types'

/** Represents a media file (image) or folder returnable from any picker. */
export interface MediaAsset {
    _id: string
    name: string
    url: string
    thumbnail_url?: string
    data_type: string
    isFolder: boolean
}

/**
 * Represents a document/info reference returnable from document pickers.
 * Used by Phase C (DocumentPickerModal — not in scope for this phase).
 */
interface DocumentRef {
    _id: string
    name: string
    url?: string
    content?: string
    data_type: string
}
void (null as any as DocumentRef)

/** Project a full DocumentInterface down to a MediaAsset. */
export function toMediaAsset(doc: DocumentInterface): MediaAsset {
    return {
        _id: doc._id,
        name: doc.name,
        url: doc.url,
        thumbnail_url: undefined,
        data_type: doc.data_type || 'info',
        isFolder: doc.isFolder,
    }
}

/** Returns true if the URL looks like a browseable image (not a doc or video). */
export function isImageUrl(url: string | undefined | null): boolean {
    if (!url) return false
    return !url.includes('.txt') && !url.includes('.pdf') && !url.includes('.mp4')
}
